$(function(){
$('.description-toggle').click(function(){
	$(this).toggleClass('active').closest('.profile-card').toggleClass('active');
});
function activeonScroll(cls){
					var scrollHeight = $(window).scrollTop(),
						hrf = $(cls).data('href'),
						thisPosition = $(hrf).offset().top;
					if(scrollHeight >= thisPosition - 101) {
						$(cls).addClass('active').siblings().removeClass('active');
					}
					else {
						$(cls).removeClass('active');
					}
				}
				$('.scroll_active').each(function(){
					activeonScroll(this);
				});
				$(window).scroll(function(){
					$('.scroll_active').each(function(){
						activeonScroll(this);
					});
				});
				$('.section-menu ul li a').click(function(e){
					e.preventDefault();
					var hash = $(this).attr('href');
					var ofst = $(hash).offset().top - 99;
					$('html, body').animate({
						scrollTop: ofst
					}, 1000, function(){        
					});
					e.stopPropagation();
				});



				
	
			});